import type { SubjectSpeakerRolePayload } from '@Application/SubjectTypes/Actions/subjectTypesFetched';

/** A role a transcript speaker can take for a dossier of this type. */
class SubjectSpeakerRoleView {
	readonly key: string;
	readonly label: string;

	constructor(payload: SubjectSpeakerRolePayload) {
		this.key = payload.key;
		this.label = payload.label;

		Object.freeze(this);
	}
}

export default SubjectSpeakerRoleView;
